<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Modal
        v-model="modal1"
        :title=modalTitle
        @on-ok="ok"
        @on-cancel="cancel">

        <Form :model="formItem" :label-width="80">
          <Form-item label="输入框">
            <Input v-model="formItem.title" placeholder="请输入"></Input>
          </Form-item>

        </Form>

      </Modal>
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="分类名称："  label-for="key">
              <Input search enter-button placeholder="请输入" clearable v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add"  >添加学习分类</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row.id)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
<!--    <modalSure ref="modalSure" :confirm="confirm" :id="formItem.id" title="分类" :modelApi="modelApi" @closeModal="closeModal"></modalSure>-->
  </div>

</template>

<script>
import { articleList,eidtCate,CateInfo,delNew } from '@/api/newsCate'
import modalSure from '@/components/modalSure'
export default {
  name: 'articleList',
  inject: ['reload'],
  components: { modalSure },
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        type: 1,
        key: ''
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      formItem: {
        id:0,
        title: '',
      },
      modalTitle:'',
      modelApi: delNew,
      article_id: 0,
      editShow: false,
      dataCount: 0,
      userInfo: [],
      loading: false,
      modal1: false,
      userid: 0,
      columns2: [
        {
          title: '分类标题',
          key: 'title',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.articleList()
  },
  methods: {
    articleList () {
      this.loading = true
      articleList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.articleList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.articleList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.modal1 = true
      this.modalTitle = '修改学习分类';

      CateInfo(id).then(res => {
        let data = res.data

        this.formItem.id = data.id
        this.formItem.title = data.title
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    del (id) {
      this.formItem.id = id
      this.$refs.modalSure.isShow = true
    },
    add () {
    this.modal1 = true
    this.modalTitle = '添加学习分类';
    this.formItem.id=0;
    this.formItem.title='';
      // this.$router.push({ path: '/admin/newscate/edit' })
    },
    ok () {
      let data = {
        'id': this.formItem.id,
        'title': this.formItem.title,
      }
      eidtCate(data).then(res => {
        let msg = '添加成功'
        if (data.id > 0) {
          msg = '编辑成功'
        }
        if (res.code === 200) {
          this.$Message.success(msg)
          this.modal1 = false
          this.articleList()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    cancel () {
      this.modal1 = false
    },
    closeModal () {
      this.articleList()
    }
  }
}
</script>
